export const FTS_9704_LABEL = "FTS9704";
export const RELAY_1_ID = "relay1";
export const RELAY_2_ID = "relay2";
export const RELAY_3_ID = "relay3";
export const BUZZER_1_ID = "buzzer";
export const COMMAND_PENDING_STATUS = ["created", "published"]; // TODO: complete ?
export const COMMAND_SUCCESS_STATUS = ["success", "delivered"]; // TODO: complete ?
export const COMMAND_FAILURE_STATUS = ["failure"]; // TODO: complete ?